import { Injector } from '@angular/core';
import { FUND_CHART_APP_STATE_SLICE_KEY, FUND_CHART_STATE_KEYS, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { AppStateService } from 'Angular/services/app-state.service';
import { AppStateManager } from 'Angular/services/app-state-manager.service';
import { FundChartUrlDeserializer } from 'ChartApp/ts/features/fund-chart-page-shared/fund-chart.serializers';
import * as i0 from "@angular/core";
export class FundChartAppStateManager extends AppStateManager {
    // AppStateService is lazily resolved to avoid a circular dependency: this service is
    // providedIn: 'root' and AppStateService depends on ActivatedRoute, which isn't available
    // on pages without a Router.
    constructor(injector) {
        super(null);
        this.injector = injector;
    }
    resolveAppStateService() {
        if (this.appStateService === null) {
            this.appStateService = this.injector.get(AppStateService, null);
        }
    }
    initAppState() {
        this.resolveAppStateService();
        if (!this.appStateService)
            return;
        this.appStateService.setStateSlice(FUND_CHART_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(FUND_CHART_STATE_KEYS);
        this.appStateService.setCustomUrlParamDeserializer(FundChartUrlDeserializer);
        this.appStateService.start();
    }
}
FundChartAppStateManager.ɵfac = function FundChartAppStateManager_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartAppStateManager)(i0.ɵɵinject(i0.Injector)); };
FundChartAppStateManager.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FundChartAppStateManager, factory: FundChartAppStateManager.ɵfac, providedIn: 'root' });
